module.exports = __webpack_public_path__ + "img/icon-filter.4fdcc805.png";